import React from 'react'

import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as PoziUtils from 'api/utils'
import { setLayerFilter } from 'drawer/tabs/layers/actions'

// .MuiFormLabel-root-66.MuiFormLabel-focused-67
// https://material-ui.com/demos/text-fields/#customized-inputs
const styles = theme => ({
  root: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 10
  },
  main: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  select: {},
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: '250px',
    'text-align': 'left',
    'margin-left': 0,
    'padding-left': 0,
    'border-left': 0
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  cssLabel: {
    'font-weight': 'normal',
    '&$cssFocused': {
      color: '#424242'
    }
  },
  cssFocused: {}
})

class FilterSelect extends React.Component {
  constructor (props) {
    super(props)
    const { layerFilter, layerPropsFilter } = this.props
    let bValidFilter = false
    if (layerFilter.length > 0) {
      bValidFilter = true
    }

    const selectValues = []
    for (const key in layerFilter) {
      const value = layerFilter[key]
      const title = get(value, 'overrides.title', '')
      if (title !== '') {
        selectValues.push(value)
      }
    }

    let defaultSelectedProp = get(layerFilter, '[0].overrides.title', '')
    if (layerPropsFilter && layerPropsFilter.prop && layerPropsFilter.prop !== '') {
      defaultSelectedProp = layerPropsFilter.prop
    }

    this.state = {
      selectValues,
      bValidFilter,
      selectedProp: defaultSelectedProp
    }
  }

  getFilter (titleIn) {
    const { layerFilter } = this.props
    for (const key in layerFilter) {
      const value = layerFilter[key]
      const title = get(value, 'overrides.title', '')
      if (title === titleIn) {
        return value
      }
    }
  }

  handleChange = event => {
    const { titleid, setLayerFilter } = this.props
    const value = get(event, 'target.value', null)
    if (isNil(value)) {
      return
    }
    const filter = this.getFilter(value)
    this.setState({ selectedProp: value })
    const propsFilter = {
      prop: value,
      value: ''
    }
    setLayerFilter(titleid, propsFilter)

    console.log('FilterSelect handleChange event', filter)
    const params = get(filter, 'overrides.config.params', null)
    if (isNil(params)) {
      return
    }
    PoziUtils.olLayerSourceUpdateParams(titleid, params)
  }

  render () {
    const { bValidFilter, selectValues } = this.state
    const { classes, titleid } = this.props
    if (!bValidFilter) {
      return null
    }

    const noneKey = 'no-filter-' + titleid
    const menuItemArr = []
    menuItemArr.push(
      <MenuItem key={noneKey} value="(None)">
        <em>(None)</em>
      </MenuItem>
    )
    // var sortedArr = selectValues.sort()
    // sortedArr = PoziUtils.removeExcludedPropertiesFromArray(sortedArr)
    for (let i = 0; i < selectValues.length; i++) {
      const label = get(selectValues[i], 'overrides.title', '')
      const labelDisplay = startCase(toLower(label))
      menuItemArr.push(
        <MenuItem key={i} value={label}>
          <em>{labelDisplay}</em>
        </MenuItem>
      )
    }

    const id = 'layers-filter-select-options-' + titleid

    return (
      <div className="pozi-layer-filter-prop-select">
        <div className={classes.root}>
          <form className={classes.main} autoComplete="off">
            <FormControl className={classes.formControl}>
              <InputLabel
                shrink
                classes={{
                  root: classes.cssLabel,
                  focused: classes.cssFocused
                }}
                className={classes.inputLabel}
                htmlFor={id}
              >
                Category...
              </InputLabel>
              <Select
                className={classes.select}
                value={this.state.selectedProp}
                onChange={this.handleChange.bind(this)}
                displayEmpty
                inputProps={{
                  name: 'selectedProp',
                  id
                }}
              >
                {menuItemArr}
              </Select>
            </FormControl>
          </form>
        </div>
      </div>
    )
  }
}

FilterSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  titleid: PropTypes.string.isRequired,
  selectValues: PropTypes.array,
  geojson: PropTypes.object,
  layerPropsFilter: PropTypes.object,
  layerFilter: PropTypes.array.isRequired,
  typelower: PropTypes.string.isRequired,
  setLayerFilter: PropTypes.func.isRequired
}

function mapStateToProps (state, ownProps) {
  const layerConf = get(state, 'layers[' + ownProps.titleid + ']')
  const layerPropsFilter = get(layerConf, 'propsFilter', null)
  const layerFilter = get(layerConf, 'filter', [])
  const typelower = toLower(get(layerConf, 'type', ''))
  return {
    layerPropsFilter,
    layerFilter,
    typelower
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setLayerFilter: (titleid, propsFilter) => {
      dispatch(setLayerFilter(titleid, propsFilter))
    }
  }
}

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FilterSelect)
)
